export const ONLINE_USERS_LOAD = 'ONLINE_USERS_LOAD';
export const ONLINE_USERS_LOAD_SUCCESS = 'ONLINE_USERS_LOAD_SUCCESS';
export const ONLINE_USERS_LOAD_ERROR = 'ONLINE_USERS_LOAD_ERROR';
export const ONLINE_USER_UPDATE = 'ONLINE_USERS_UPDATE';
export const ONLINE_USER_REMOVE = 'ONLINE_USERS_REMOVE';